import React, { useState, useEffect } from 'react';
import './EditorStyles.css';

const NavbarEditor = () => {
  const [navbarItems, setNavbarItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    loadContent();
  }, []);

  const loadContent = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL || 'https://server.acpca.net/api'}/content/all`);
      const data = await response.json();
      if (data.success) {
        setNavbarItems(data.data.navbar || []);
      }
    } catch (error) {
      console.error('Error loading content:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async (item) => {
    setSaving(true);
    setMessage('');

    try {
      const token = localStorage.getItem('dashboard_token');
      const response = await fetch(`${process.env.REACT_APP_API_URL || 'https://server.acpca.net/api'}/content/navbar/${item.key_name}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          content_ar: item.content_ar,
          content_en: item.content_en
        })
      });

      const data = await response.json();
      if (data.success) {
        setMessage('تم حفظ عنصر القائمة بنجاح!');
        setTimeout(() => setMessage(''), 3000);
      } else {
        setMessage(data.message || 'خطأ في حفظ المحتوى');
      }
    } catch (error) {
      setMessage('خطأ في الاتصال');
      console.error('Save error:', error);
    } finally {
      setSaving(false);
    }
  };

  const handleItemChange = (index, field, value) => {
    const updated = [...navbarItems];
    updated[index] = { ...updated[index], [field]: value };
    setNavbarItems(updated);
  };

  if (loading) {
    return <div className="editor-loading">جاري التحميل...</div>;
  }

  return (
    <div className="editor-container">
      <div className="editor-header">
        <h2>محرر القائمة</h2>
        {message && (
          <div className={`editor-message ${message.includes('نجح') || message.includes('success') ? 'success' : 'error'}`}>
            {message}
          </div>
        )}
      </div>

      <div className="editor-items-list">
        {navbarItems.map((item, index) => (
          <div key={item.id || index} className="editor-item-card">
            <div className="editor-item-content" style={{ flex: 1 }}>
              <h4>{item.key_name}</h4>
              <div className="editor-grid" style={{ marginTop: '15px', gap: '15px' }}>
                <div className="editor-form-group">
                  <label>المحتوى العربي</label>
                  <input
                    type="text"
                    value={item.content_ar || ''}
                    onChange={(e) => handleItemChange(index, 'content_ar', e.target.value)}
                  />
                </div>
                <div className="editor-form-group">
                  <label>المحتوى الإنجليزي</label>
                  <input
                    type="text"
                    value={item.content_en || ''}
                    onChange={(e) => handleItemChange(index, 'content_en', e.target.value)}
                  />
                </div>
              </div>
            </div>
            <div className="editor-item-actions">
              <button 
                className="editor-btn-sm editor-btn-edit" 
                onClick={() => handleSave(item)}
                disabled={saving}
              >
                {saving ? 'جاري الحفظ...' : 'حفظ'}
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default NavbarEditor;

